export { default } from "./divider"
